module.exports = __webpack_public_path__ + "img/官网-证书-投屏.d78f8128.png";